import santaDataRefs from '@wix/document-services-json-schemas/dist/santaDataRefs.json' // eslint-disable-line no-restricted-syntax
import { DataMapName } from '@wix/thunderbolt-becky-types'

export type Schema<T extends Record<string, any>> = { [key in keyof T]: boolean | Schema<T[key]> }

const getSantaDataItems = () => {
	// Remove Menu dataItem
	const { Menu, ...data } = santaDataRefs.Data // eslint-disable-line @typescript-eslint/no-unused-vars

	// Fix PageIds to be resolved with fallback to the pageId if the page data doesn't exist
	data.AnchorLink.pageId = true
	data.PageLink.pageId = true
	// @ts-ignore
	data.AnchorLink.anchorDataId = true
	// MultiStateBox's selectedStateId should not be resolved and should fallback
	data.MultiStateBoxData.selectedStateId = true

	// EE-library is not built into santaDataRefs right now. should be removed after implementing
	// @ts-ignore
	data.MultiStateBoxData.a11y = true

	// Internal ref rootCompId is now a weakRef
	data.InternalRef.rootCompId = true

	return data
}

const getSantaStyleDataItems = () => {
	// Fix breakpoint to be resolved with fallback to the breakpointId because we don't
	// resolve refs to different data maps
	santaDataRefs.Style.BreakpointRelation.breakpoint = true
	return santaDataRefs.Style
}

const allSchemas = ({
	document_data: getSantaDataItems(),
	design_data: santaDataRefs.Design,
	component_properties: santaDataRefs.Properties,
	theme_data: getSantaStyleDataItems(),
	breakpoints_data: {
		BreakpointsData: {
			values: false,
		},
	},
	variants_data: {
		BreakpointsData: {
			values: false,
		},
	},
	transformations_data: {
		VariantRelation: {
			to: false,
		},
		RefArray: {
			values: false,
		},
	},
	transitions_data: {
		VariantRelation: {
			to: false,
		},
		RefArray: {
			values: false,
		},
	},
	reactions: {
		VariantRelation: {
			to: false,
		},
		RefArray: {
			values: false,
		},
		Reactions: {
			values: false,
		},
	},
} as any) as Partial<Record<DataMapName, Record<string, Schema<any>>>>

export default allSchemas
